import { nanoid } from 'nanoid';

import { UPDATE_LEAD, UPDATE_ELEVATOR_DATA, SET_ELEVATOR_INDEX, UPDATE_CONFIGURATION, REMOVE_ELEVATOR, RESET, SET_MODE, ADD_ELEVATOR } from './ActionTypes';
import { getStorageItem, setStorageItem, clearStorage } from '../helper/sessionStorage';

const sessionStorageData = getStorageItem();
const initialData = {
	elevatorIndex: 0,
	lead: {
		role: 14,
		customer: 1,
		job: '',
		subject: 'Anfrage',
		message: 'Digital Media Services - Konfiguration',
		widget_identifier: "DMSC",
		widget_url: window.location.href
	},
	configuration: {
		elevators: [],
	},
}

export const initialState = sessionStorageData
	? sessionStorageData
	: initialData;

export const formReducer = (state, action) => {
	let newState;
	const { configuration } = state;

	switch (action.type) {
		case UPDATE_CONFIGURATION:
			console.log('UPDATE_CONFIGURATION:', action.payload);
			newState = {
				...state,
				configuration: {
					...state.configuration,
					...action.payload,
				}
			};

			setStorageItem(newState);
			return newState;

		case UPDATE_LEAD:
			console.log('UPDATE_LEAD:', action.payload);
			newState = {
				...state,
				lead: {
					...state.lead,
					...action.payload,
				}
			};

			setStorageItem(newState);
			return newState;

		case ADD_ELEVATOR:
			console.log('ADD_ELEVATOR_DATA:', action.payload);
			
			newState = {
				...state,
				configuration: {
					...configuration,
					elevators: [
						...configuration.elevators,
						{ ...action.payload, id: nanoid(10) }
					],
				}
			}

			setStorageItem(newState);
			return newState

		case UPDATE_ELEVATOR_DATA:
			console.log('UPDATE_ELEVATOR_DATA:', action.payload);
		
			newState = {
				...state,
				configuration: {
					...configuration,
					elevators: [
						...configuration.elevators.slice(0, state.elevatorIndex),
						{
							...configuration.elevators[state.elevatorIndex],
							...action.payload,
						},
						...configuration.elevators.slice(state.elevatorIndex + 1),
					],
				}
			};

			setStorageItem(newState);
			return newState;

		case REMOVE_ELEVATOR:
			console.log('REMOVE_ELEVATOR:', action.payload);

			newState = {
				...state,
				configuration: {
					...configuration,
					elevators: configuration.elevators.filter(item => item !== configuration.elevators[action.payload])
				}
			};

			setStorageItem(newState);
			return newState;

		case SET_ELEVATOR_INDEX:
			console.log('SET_ELEVATOR_INDEX:', action.payload);

			newState = {
				...state,
				elevatorIndex: action.payload,
			};

			setStorageItem(newState);
			return newState;

		case RESET:
			clearStorage();

			return initialData;

		case SET_MODE:
			return {
				...state,
				mode: action.payload,
			}

		default:
			return state;
	}
};
